import {createContext, useContext, useEffect, useState, useCallback} from 'react'

import { useDispatch, useSelector } from 'react-redux'
import { useCouponAndModalForms } from '../../../couponAndModalFormsContext'
import { toast } from 'react-toastify'
import { api } from '../../../../../../../services/api'
import moment from 'moment'
import { useAuth } from '../../../../../../../context/AuthContext'


export const CouponValidityContext = createContext();


export function CouponValidityProvider({ children }){
    const {  
        couponDatasToCreateOrEdit, 
        setCouponDatasToCreateOrEdit,
        fetchData,
        listBusinessToFilter,
        totalCoupons,
        franchiseListCodesSelected
    } = useCouponAndModalForms()


    const { signOut } = useAuth()

    const modalForms = useSelector(state => state.modalForms)

    const dispatch = useDispatch()
    const date = new Date();
    const [initialValidityDate, setInitialValidityDate] = useState(moment(date).format('YYYY-MM-DD'))
    const [lastValidityDate, setLastValidityDate] = useState(moment(date).format('YYYY-MM-DD'))

    const [noEndDate, setNoEndDate] = useState(false)

    const [isLoading, setIsLoading] = useState(false)

    const usedCoupons = totalCoupons - couponDatasToCreateOrEdit.remainingQuantity
    const remainingQ = couponDatasToCreateOrEdit.unlimited === false  ? couponDatasToCreateOrEdit.availableQuantity - (isNaN(usedCoupons) ? 0 : usedCoupons) : 0
     

    const dateSanitation = useCallback((date) =>{
        const dateSplit = new Date(date).toLocaleDateString('pt-BR', {timeZone: 'UTC'}).split('')
        return `${dateSplit[6] + dateSplit[7] + dateSplit[8] 
            + dateSplit[9] + '-' + dateSplit[3] 
            + dateSplit[4] + '-' + dateSplit[0] + dateSplit[1]}` 
    }, [])


    const setCouponOnList = useCallback(() =>{
        if(remainingQ < 0){
            toast.error('Impossível cadastrar essa quantidade de coupons')
            return
        }
       
        fetchData()

        dispatch({type: ''})
        setCouponDatasToCreateOrEdit({})
    }, [remainingQ, dispatch, fetchData, setCouponDatasToCreateOrEdit])


    const handleCreateCoupon = useCallback(async () => {       
        setIsLoading(true)

        try{
            if(initialValidityDate === '' || (lastValidityDate === '' && noEndDate === false))
                throw new Error('Preencha a data do cupom')

            if(moment(initialValidityDate) > moment(lastValidityDate))
                throw new Error('ℹ️ Data final menor que a  Data inicial')

            if(listBusinessToFilter.length > 1){
                if(franchiseListCodesSelected.length > 1){
                    throw new Error('Somente selecionar uma franquia !');
                }

                if(franchiseListCodesSelected.length <= 0){
                    throw new Error('Selecione pelo menos uma franquia')
                }

                let obj = {
                    ...couponDatasToCreateOrEdit,
                    idCoupon: 0,
                    franchiseListCodesSelected: franchiseListCodesSelected,
                }

                const response = await api.post('/saveCouponFranquia', obj, {
                    headers:{
                        'Content-Type' : 'application/json',
                        token: localStorage.getItem('@Inoveclube:token')
                    }
                })

                if(response.data.success === 0){
                    throw new Error(response.data.message)
                }
                setIsLoading(false);
                setCouponOnList('createCoupon')
                toast.success('Cupom para franquia cadastrada !');
            }
            else{
                //console.log(initialValidityDate)
                let obj = {
                    ...couponDatasToCreateOrEdit,
                    idCoupon: 0,
                    business: listBusinessToFilter,
                    startDate: initialValidityDate,
                    endDate: lastValidityDate
                }

                const response = await api.post('/saveCoupon', obj, {
                    headers:{
                        'Content-Type' : 'application/json',
                        token: localStorage.getItem('@Inoveclube:token')
                    }
                })
    
                const { success, message } = response.data
    
                if(success === 1){
                    setIsLoading(false)
                    setCouponOnList('createCoupon')
                    toast.success(message)
                }else{
                    setIsLoading(false)
                    toast.error(message)
                }
            }
        }catch(error){
            //console.log(error)
            setIsLoading(false)
            if(error.response){
              if(error.response.status === 401 || error.response.status === 500){
                signOut()
                toast.warning('Sua sessão foi expirada')
              }else{
                toast.error(error.response.data.message)
              }
            }else{
              toast.info(error.message)
            }        
            
        }
        
    }, [
        initialValidityDate, 
        lastValidityDate, 
        couponDatasToCreateOrEdit, 
        signOut,
        listBusinessToFilter,
        noEndDate,
        setCouponOnList,
        franchiseListCodesSelected
    ]) 

    // const handleCreateCouponFranquia = useCallback(async () => {
    //     let obj = {
    //         ...couponDatasToCreateOrEdit,
    //         idCoupon: 0,
    //         business: listBusinessToFilter,
    //     }
       
    //     setIsLoading(true)

    //     try{
    //         if(initialValidityDate === '' || (lastValidityDate === '' && noEndDate === false))
    //             throw new Error('Preencha a data do cupom')

    //         if(moment(initialValidityDate) > moment(lastValidityDate))
    //             throw new Error('ℹ️ Data final menor que a  Data inicial')

    //         const response = await api.post('/saveCoupon', obj, {
    //             headers:{
    //                 'Content-Type' : 'application/json',
    //                 token: localStorage.getItem('@Inoveclube:token')
    //             }
    //         })

    //         const { success, message } = response.data

    //         if(success === 1){
    //             setIsLoading(false)
    //             setCouponOnList('createCoupon')
    //             toast.success(message)
    //         }else{
    //             setIsLoading(false)
    //             toast.error(message)
    //         }


    //     }catch(error){
    //         setIsLoading(false)
    //         if(error.response){
    //           if(error.response.status === 401 || error.response.status === 500){
    //             signOut()
    //             toast.warning('Sua sessão foi expirada')
    //           }else{
    //             toast.error(error.response.data.message)
    //           }
    //         }else{
    //           toast.info(error.message)
    //         }        
            
    //     }
    // },[initialValidityDate, lastValidityDate, couponDatasToCreateOrEdit, signOut,listBusinessToFilter,noEndDate,setCouponOnList])
 

    const handleEditCoupon = useCallback(async () => {
        let obj = {
            ...couponDatasToCreateOrEdit,
            startDate: initialValidityDate,
            endDate: lastValidityDate,
            business: listBusinessToFilter
        }
        console.log(obj)
        setIsLoading(true)

        try{
            if(initialValidityDate === '' || (lastValidityDate === '' && noEndDate === false))
                throw new Error('Preencha a data do cupom')

            if(moment(initialValidityDate) > moment(lastValidityDate))
                throw new Error('Data inicial menor que a  Data final')

            if(remainingQ < 0)
                throw new Error('Impossível cadastrar essa quantidade de coupons')

            const response = await api.post('/saveCoupon', obj, {
                headers:{
                    'Content-Type' : 'application/json',
                    token: localStorage.getItem('@Inoveclube:token')
                }
            })

            const { success, message } = response.data

            if(success === 1){
                setIsLoading(false)
                setCouponOnList('editCoupon')
                toast.success(message)
            }else{
                setIsLoading(false)
                toast.error(message)
            }


        }catch(error){
            setIsLoading(false)
            if(error.response){
              if(error.response.status === 401 || error.response.status === 500){
                signOut()
                toast.warning('Sua sessão foi expirada')
              }else{
                toast.error(error.response.data.message)
              }
            }else{
              toast.info(error.message)
            }        
            
        }

    }, [
        initialValidityDate, 
        lastValidityDate, 
        couponDatasToCreateOrEdit, 
        signOut,
        listBusinessToFilter,
        noEndDate,
        remainingQ,
        setCouponOnList
    ])


    useEffect(() =>{
        if(modalForms.typeModal === 0){
            setInitialValidityDate( dateSanitation(couponDatasToCreateOrEdit.startDate) )
            setLastValidityDate( dateSanitation(couponDatasToCreateOrEdit.endDate) )
            setNoEndDate(couponDatasToCreateOrEdit.noEndDate)
        }
    }, [couponDatasToCreateOrEdit, dateSanitation, modalForms])
  


    useEffect(() =>{
        if(modalForms.isOpen === false){
            // setInitialValidityDate('')
            // setLastValidityDate('')
            setNoEndDate(false)
        }
    }, [modalForms])


    useEffect(() => {
        if(noEndDate){
            setLastValidityDate('')
        }
        else{
            setLastValidityDate(moment().format('YYYY-MM-DD'))
        }
    }, [noEndDate])


    return(
        <CouponValidityContext.Provider 
            value={ { 
                initialValidityDate, setInitialValidityDate,
                lastValidityDate, setLastValidityDate,
                handleCreateCoupon,
                handleEditCoupon,
                noEndDate, setNoEndDate,
                isLoading
            } }
        >
            { children }
        </CouponValidityContext.Provider>
    )
}



export function useCouponValidity() {
   const context = useContext(CouponValidityContext)

   if(!context) {
    throw new Error('useCouponValidity must be used within an Provider');
  } 

   return context
}
